function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(20277 -2110)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-19020.049 -1240.081)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1251.951 3359.34)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1231.091,3363.2c-.813,0-1.574.006-2.334-.01-.07,0-.187-.137-.2-.219a6.338,6.338,0,0,1-.009-.762c0-.2-.08-.295-.282-.283-.072,0-.145,0-.218,0H-1246.3c-.484,0-.485,0-.485.469,0,2.76.007,5.521-.008,8.281,0,.369.1.475.47.473,2.736-.013,5.472,0,8.208-.014.355,0,.478.076.467.459-.03,1.016-.018,2.033,0,3.05,0,.265-.067.363-.344.362-3.777-.007-7.555.008-11.332-.01a2.609,2.609,0,0,1-2.625-2.674c-.006-1.146.028-1.18,1.185-1.18.339,0,.679-.017,1.017,0,.318.02.416-.094.414-.414-.012-2.4-.007-4.794-.007-7.191,0-.7,0-1.4,0-2.107a1.979,1.979,0,0,1,2.1-2.091q7.01,0,14.02,0a1.967,1.967,0,0,1,2.128,2.128C-1231.091,3362.024-1231.091,3362.579-1231.091,3363.2Z",
  transform: "translate(1251.951 -3359.339)",
  fill: "currentColor",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1236.268 3364.551)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1025.715,3434.888v.325q0,3.286,0,6.572a1.422,1.422,0,0,1-1.568,1.559h-7.255a1.4,1.4,0,0,1-1.539-1.526q0-4.561,0-9.122a1.443,1.443,0,0,1,1.62-1.617c1.542,0,3.084.005,4.627-.005.25,0,.33.062.325.321-.017.806-.008,1.612-.006,2.418a.977.977,0,0,0,1.078,1.073c.806,0,1.612,0,2.419,0Z",
  transform: "translate(1036.078 -3431.074)",
  fill: "currentColor",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-929.241,3436.333h-1.246c-.376,0-.753,0-1.129,0-.138,0-.238-.022-.237-.2,0-.771,0-1.541,0-2.311a.353.353,0,0,1,.024-.1Z",
  transform: "translate(939.425 -3433.534)",
  fill: "currentColor",
  fillRule: "evenodd"
}))), /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-20277 2110)",
  fill: "none"
}));

function SvgIconApsManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApsManager);
export default __webpack_public_path__ + "static/media/icon-aps-manager.241c1f3e.svg";
export { ForwardRef as ReactComponent };